import type { Component, Entity2D } from '../../odie';

import { CandyBlockProps } from '../defs/block';
import { CandyBlockView } from '../views/blocks/CandyBlockView';

// types
//-----------------------------------------------------------------------------
export type CandyBlockComponentOptions = {
  props: CandyBlockProps;
};

/*
    candy block component
*/
export class CandyBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCandy';

  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: CandyBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: CandyBlockComponentOptions): void {
    this.view = new CandyBlockView({ ...options.props });
  }
}
